var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { classNames } from '../utils';
const badgeVariants = cva('inline-flex items-center justify-center font-medium w-fit whitespace-nowrap shrink-0 gap-1 transition-[color,box-shadow] overflow-hidden', {
    variants: {
        variant: {
            default: 'bg-gray-100 text-gray-700',
            secondary: 'bg-gray-50 text-gray-600',
            error: 'bg-red-50 text-red-700',
            warning: 'bg-yellow-50 text-yellow-800',
            success: 'bg-green-50 text-green-700',
            blue: 'bg-blue-50 text-blue-700',
            indigo: 'bg-indigo-50 text-indigo-700',
            purple: 'bg-brand-50 text-brand-700',
            pink: 'bg-pink-50 text-pink-700',
            outline: 'bg-transparent text-gray-700 ring-1 ring-inset ring-gray-300',
        },
        size: {
            xs: 'px-1.5 py-0.5 text-tiny leading-tight',
            sm: 'px-1.5 py-0.5 text-xs leading-tight',
            md: 'px-2 py-1 text-xs',
            lg: 'px-2.5 py-1.5 text-sm',
        },
        rounded: {
            full: 'rounded-full',
            md: 'rounded-md',
            sm: 'rounded-sm',
            none: 'rounded-none',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'md',
        rounded: 'md',
    },
});
function Badge(_a) {
    var { className, variant, size, rounded, asChild = false } = _a, props = __rest(_a, ["className", "variant", "size", "rounded", "asChild"]);
    const Comp = asChild ? Slot : 'span';
    return (_jsx(Comp, Object.assign({ "data-slot": "badge", className: classNames(badgeVariants({ variant, size, rounded }), className) }, props)));
}
export { badgeVariants };
export default Badge;
